module.exports = __webpack_public_path__ + "static/media/fruits-03.07ea1b73.png";


//////////////////
// WEBPACK FOOTER
// ./src/fruits-03.png
// module id = 204
// module chunks = 0